import React, { createContext, useContext, useMemo, useState } from 'react'
import { ThemeProvider as Themed } from '@mui/material/styles'
import { CssBaseline, useMediaQuery } from '@mui/material'
import { useDefaultWyesTheme } from './themes'

const ColorModeContext = createContext({
  mode: null,
  toggleColorMode: () => {
    console.error('early call to toggleColorMode()')
  }
})

export const useColorMode = () => useContext(ColorModeContext)

export default function WyesThemeProvider({ children = null }) {
  const [mode, setMode] = useState(
    useMediaQuery('(prefers-color-scheme: dark)') ? 'dark' : 'light'
  )

  const colorMode = useMemo(
    () => ({
      mode,
      toggleColorMode: () => {
        setMode(mode === 'light' ? 'dark' : 'light')
      }
    }),
    [mode]
  )

  const theme = useDefaultWyesTheme(mode);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <Themed theme={theme}>
        <CssBaseline />
        {children}
      </Themed>
    </ColorModeContext.Provider>
  )
}
